// Pure world-space X/Z bounds helpers. Camera and output-scope state remain
// with the host, which supplies renderBounds (null means a complete render).
export function validRenderBounds(bounds) {
  return Boolean(bounds)
    && [bounds.minX, bounds.minZ, bounds.maxX, bounds.maxZ].every(Number.isFinite)
    && bounds.minX <= bounds.maxX && bounds.minZ <= bounds.maxZ;
}

export function boundsIntersect(a, b) {
  // Incomplete bounds cannot prove that geometry is outside the viewport.
  if (!validRenderBounds(a) || !validRenderBounds(b)) return true;
  return !(a.maxX < b.minX || a.minX > b.maxX || a.maxZ < b.minZ || a.minZ > b.maxZ);
}

export function boundsContain(a, b) {
  return validRenderBounds(a) && validRenderBounds(b)
    && a.minX <= b.minX && a.minZ <= b.minZ
    && a.maxX >= b.maxX && a.maxZ >= b.maxZ;
}
